import React, { memo } from 'react';

export const SidebarAnimations: React.FC = memo(() => (
  <style>{`
    @keyframes sidebarFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes sidebarSlideInLeft {
      from {
        opacity: 0;
        transform: translateX(-20px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes sidebarSlideDown {
      from {
        transform: translateY(-100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes sidebarSlideInTop {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes sidebarDropdownSlide {
      from {
        opacity: 0;
        transform: translateY(-10px) scaleY(0.9);
      }
      to {
        opacity: 1;
        transform: translateY(0) scaleY(1);
      }
    }

    @keyframes sidebarFadeInScale {
      from {
        opacity: 0;
        transform: scale(0.9);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    @keyframes sidebarNavItemSlideIn {
      from {
        opacity: 0;
        transform: translateX(-20px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateX(0) scale(1);
      }
    }

    @keyframes sidebarFadeInDelayed {
      0% {
        opacity: 0;
        transform: translateX(-50%) translateY(5px);
      }
      100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
  `}</style>
));

SidebarAnimations.displayName = 'SidebarAnimations';
